import { render } from "./List.vue?vue&type=template&id=2133c814&ts=true"
import script from "@/composables/pages/approve-deposit/ApprovedDepositTableComposable.ts?vue&type=script&lang=ts"
export * from "@/composables/pages/approve-deposit/ApprovedDepositTableComposable.ts?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=2133c814&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__